<template>
  <h5 v-if="displayTitle" class="view-title" :class="extraClass">{{ displayTitle }}</h5>
</template>

<script>
import { visibleViewTitle } from '../../../shared/view-title.js'

export default {
  name: 'ViewTitle',
  props: {
    title: { type: String, default: '' },
    extraClass: { type: String, default: '' }
  },
  computed: {
    displayTitle () {
      return visibleViewTitle(this.title)
    }
  }
}
</script>

<style>
.view-title {
  margin: 0 0 0.75rem;
  padding: 0;
  text-align: left;
  font-family: inherit;
  font-size: 1.25rem;
  font-weight: 500;
  font-style: normal;
  line-height: 1.2;
  letter-spacing: normal;
  text-transform: none;
  text-decoration: none;
  color: inherit;
}
</style>
